module.exports = __webpack_public_path__ + "img/advice.232728ed.jpg";